import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AreaChartSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AreaChartSVG;
